<template>
  <tr :style="{'cursor': 'pointer'}" @click="handleItemClick">
    <td>{{ item.title }}</td>
    <td>{{ item.reportEmail | NoEmpty }}</td>
    <td>{{ reportSendMode | NoEmpty }}</td>
    <td>{{ formattedPeriodExecution }}</td>
    <td>{{ item.contractNumber | NoEmpty }} <span v-if="item.contractDate" class="text-caption">(from {{reformatDate(item.contractDate)}})</span></td>
  </tr>
</template>

<script>
import 'moment-duration-format'
import NoEmpty from '../../Filters/NoEmpty'
import {formatPeriodExecution, reformatDate} from '../../../helpers/timeformats'
import _ from 'lodash'

export default {
  name: 'Item',
  props: {
    item: {
      type: Object
    },
    availableReportSendModesByValue: {
      type: Object
    },
    availableReportSendModes: {
      type: Array
    }
  },
  filters: {
    NoEmpty
  },
  data() {
    return {}
  },
  computed: {
    reportSendMode() {
      return _.get(this.availableReportSendModesByValue, [this.item.reportSendMode, 'name'])
    },
    formattedPeriodExecution() {
      return formatPeriodExecution(this.item.periodExecution)
    }
  },
  methods: {
    handleItemClick() {
      this.$emit('click', this.item)
    },
    reformatDate: reformatDate,
  }
}
</script>

<style scoped>

</style>